export const colors = {
  primary: "#b22222",
  secondary: "#85130b",
  gray_light: "#F3F3F3",
  gray: "#bfbfbf",
  warning: "#ffff66",
  success: "#009900",
  danger: "#ff0000",
};
